import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IValidationProblemDetails } from '@mds/angular-core';

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  getErrorCode(response: any): string | undefined {
    if (response instanceof HttpErrorResponse && this.isValidationError(response.error)) {
      return Object.keys(response.error.errors)[0];
    }

    return undefined;
  }

  private isValidationError(error: any): error is IValidationProblemDetails {
    const errors = (error as IValidationProblemDetails)?.errors;
    return errors !== undefined && Object.values(errors).length > 0;
  }
}
